
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ClientOppDescription')
export class ClientOppDescription {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('description', String, true)
    desc = '';

    @JsonProperty('description_ar', String, true)
    descAr = '';

    get getDescription() {
        return this.desc || this.descAr;
    }
}